module.exports = __webpack_public_path__ + "fff54ce2ac9b136ea53802820717a64e.png";